import { SELECT_CALLFILTER } from './typeConstants';

export const selectCallFilter = (data) => ({
    type: SELECT_CALLFILTER,
    data,
});
